export type StorageArea = 'local' | 'session';

// The Web Storage global is read inside the try on purpose: with Chrome's
// "block site data" setting, merely evaluating `window.localStorage` throws a
// SecurityError, so a guard around only getItem/setItem is not enough.

/** Read a key, or null when it is missing or storage is unavailable. */
export function storageGet(area: StorageArea, key: string): string | null {
  try {
    return (area === 'local' ? window.localStorage : window.sessionStorage).getItem(key);
  } catch {
    return null;
  }
}

/** Write a key; false when storage is unavailable or full. */
export function storageSet(area: StorageArea, key: string, value: string): boolean {
  try {
    (area === 'local' ? window.localStorage : window.sessionStorage).setItem(key, value);
    return true;
  } catch {
    return false;
  }
}

/** Remove a key; false when storage is unavailable. */
export function storageRemove(area: StorageArea, key: string): boolean {
  try {
    (area === 'local' ? window.localStorage : window.sessionStorage).removeItem(key);
    return true;
  } catch {
    return false;
  }
}
